export default "__VITE_ASSET__0fff5d29__"